<template>
  <div>
    <template v-if="$route.name == 'secretKey'">
      <ots-main-title></ots-main-title>
      <ots-table-group-new
        :messageDescript="messageDescript"
        :selectList="selectList"
        :requestForm="requestForm"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeNum"
        @changePage="changePage"
        @search="search"
      ></ots-table-group-new>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>


<script>
import { 
  getSelectPlanFn 
} from "@/http/modules/examSet/examBatch";

import {
  getPlanPlaceListAPI,
  queryEnterKeyListAPI,
  exportEnterKeyDetailAPI,
  serialGetSelectClassAPI
} from "@/http/modules/computedRoomExam";

import {
  getPlanAllSessionByPlan,
} from "@/http/modules/examSet/planClass";

export default {
  data() {
    return {
      messageDescript: "说明：每场开考前70分钟可查询本场次进场秘钥",
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: '秘钥类型',
          type: 'select',
          requestKey: 'keyType',
          label: 'name',
          value: 'id',
          data: [
            {name: '进场秘钥', id: "1"}, 
            {name: '签到设置秘钥', id: "2"}, 
            {name: '远程操控设置秘钥', id: "3"}
          ],
        },
        {
          title: '考点',
          type: 'select',
          requestKey: 'placeId',
          label: 'name',
          value: 'id',
          data: [],
        },
        {
          title: '教室',
          type: 'select',
          requestKey: 'classId',
          label: 'name',
          value: 'id',
          data: [],
          notShow: true,
        },
        {
          title: '场次',
          type: 'select',
          requestKey: 'sessionId',
          label: 'name',
          value: 'id',
          data: [],
        },
      ],
      pagination: {
        total: 0,
      },
      tableData: [],
      tableHeader: [
        {
          title: "批次名称",
          prop: "planName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "教室",
          prop: "className",
        },
        {
          title: "场次",
          prop: "sessionName"
        },
        {
          title: "秘钥类型",
          prop: "keyType",
        },
        {
          title:"秘钥",
          type:"buttons",
          width:"160",
          btnList:[
            { title:"查看", click: this.showSheet},
            { title:"下载", click: this.downLoad},
          ]
        }
      ],
      requestForm: {
        planId: '',
        keyType:"1",
        placeId: '',
        classId: '',
        sessionId: '',
        size: 10,
        page: 1,
      },
    }
  },
  watch: {
    'requestForm.planId': function(value) {
      this.getPlace(value);
      this.getChainSession();
      this.getTableData();
    },
    'requestForm.placeId': function(value) {
      if (this.requestForm.keyType == "3") {
        this.getClass(value);
      }
    },
    'requestForm.keyType': function(value) {
      // 进场秘钥、签到设置秘钥：隐藏教室，显示场次
      // 远程操控设置秘钥：显示教室，隐藏场次
      if(value=="1" || value=="2"){
        this.$set(this.selectList[3], 'notShow', true);  // 隐藏教室
        this.$set(this.selectList[4], 'notShow', false); // 显示场次
      } else if(value=="3"){
        this.$set(this.selectList[3], 'notShow', false); // 显示教室
        this.$set(this.selectList[4], 'notShow', true);  // 隐藏场次
        this.getClass();
      }
      if(value=="1"){
        // 进场秘钥
        this.tableHeader.splice(5,1,{
          title:"秘钥",
          type:"buttons",
          width:"160",
          btnList:[
            { title:"查看", click: this.showSheet},
            { title:"下载", click: this.downLoad},
          ]
        });
        this.getTableData();
      }else if(value=="2"){
        // 签到设置秘钥
        this.tableHeader.splice(5,1,{
          title:"秘钥",
          width:"160",
          prop: "enterKey"
        });
        this.getTableData();
      }else if (value=="3") {
        // 远程操控设置秘钥
        this.tableHeader.splice(5,1,{
          title:"秘钥",
          width:"160",
          prop: "enterKey"
        });
        this.getTableData();
      }
    },
  },
  created() {
    this.getPlan();
  },
  methods: {
    // 查询
    search() {
      this.requestForm.page = 1;
      this.getTableData();
    },

    // 获取批次
    async getPlan() {
      const { data: planData } = await getSelectPlanFn({needAudit: 31});
      this.selectList[0].data = planData;
      this.requestForm.planId = planData[0].id;
    },

    // 获取考点
    async getPlace(value) {
      const { data: placeData } = await getPlanPlaceListAPI({planId: value});
      if (!placeData) {
        this.selectList[2].data = [];
        this.requestForm.placeId = '';
        return;
      }
      this.selectList[2].data = [{id: '', name: '全部'}, ...placeData];
      this.requestForm.placeId = "";
    },

    // 获取教室
    async getClass() {
      let params = {
        planId: this.requestForm.planId,
        placeId: this.requestForm.placeId
      }
      const { data: classData } = await serialGetSelectClassAPI(params);
      if (!classData || classData.length === 0) {
        this.selectList[3].data = [];
        this.requestForm.classId = '';
        return;
      }
      this.selectList[3].data = [{id: '', name: '全部'}, ...classData];
      this.requestForm.classId = '';
    },

    // 获取场次
    async getChainSession() {
      let params = {
        planId: this.requestForm.planId,
      };
      const { code, data } = await getPlanAllSessionByPlan(params);
      if (code == 1) {
        let sessionId = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[4], "data", sessionId);
        this.requestForm.sessionId = '';
      } else {
        this.requestForm.sessionId = '';
        this.$set(this.selectList[4], "data", [{ id: "", name: "全部" }]);
      }
    },

    // 获取表格数据
    async getTableData() {
      let params = { ...this.requestForm };
      const { code, data } = await queryEnterKeyListAPI(params);
      if (code == 1) {
        this.tableData = data.records;
        this.pagination.total = data.total;
        // 判断是否需要提示
        let oCurErrorInfo = "";
        let isNeedShowTip = false;
        if(data.records.length>0){
          for(let i=0;i<data.records.length;i++){
            let oCurItem = data.records[i];
            // 是否包含有这个字段
            if(typeof oCurItem.errInfo === 'undefined'){

            }else{
              if(oCurItem.errInfo===null){

              }else{
                oCurErrorInfo = oCurItem;
                isNeedShowTip = true;
                break;
              }
            }
          }
          if(isNeedShowTip){
            this.$message.error(oCurErrorInfo.errInfo);
          }
        }
      }
    },

    // 查看
    showSheet(row) {
      let params = {...row, planId: this.requestForm.planId}
      window.localStorage.setItem('lookSecretKey',JSON.stringify(params))
      this.$router.push({
        name:'secretKeyLook',
      })
    },

    // 下载
    async downLoad(row) {
      let params = {
        placeId: row.placeId,
        planId: this.requestForm.planId,
        sessionId: row.sessionId,
      }

      const {code, data} = await exportEnterKeyDetailAPI(params);
      if (code == 1) {
        window.open(data.address);
      }
    },

    changeNum(num) {
      this.requestForm.size = num
      this.getTableData()
    },

    changePage(p) {
      this.requestForm.page = p;
      this.getTableData();
    },
  }

}
</script>